import { useRef, useState, useEffect } from 'react';
import noop from 'lodash/noop';

const useScrolledState = (isBreakpoint, window, onScrollCallback = noop) => {
  const isWatchingScroll = useRef(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const onScroll = () => {
    if (window.scrollY <= 0) {
      setIsScrolled(false);
    } else {
      setIsScrolled(true);
    }
    onScrollCallback();
  };
  useEffect(() => {
    let cleanup = noop;
    if (isBreakpoint && isWatchingScroll.current) {
      isWatchingScroll.current = false;
      window.removeEventListener('scroll', onScroll);
    }
    if (!isBreakpoint && !isWatchingScroll.current) {
      isWatchingScroll.current = true;
      window.addEventListener('scroll', onScroll);
      cleanup = () => window.removeEventListener('scroll', onScroll);
    }
    return cleanup;
  }, [isBreakpoint]);

  return isScrolled;
};

export default useScrolledState;
